/* ══════════════════════════════════════════════════════════════════════
   EL QUESITO · réplica de PROMPT_PESTANA_PAUTAS §3.2. UN TROZO POR EJERCICIO
   (nunca un %). Sector anular: los cuatro tamaños se dibujan igual, solo
   cambian cuatro números. DOS familias de estado que NO se mezclan:
     · grande (.fv-queso__trozo): es-hecho / es-parada / es-falta (+ momento)
     · roscos (.fv-qm__t):        es-si / es-no / es-medias / es-dolor
   ══════════════════════════════════════════════════════════════════════ */

// Sector anular entre dos ángulos (radianes).
function sectorAngulos(cx, cy, R, r, a0, a1, dec = 1) {
  const f = (x) => x.toFixed(dec);
  const grande = (a1 - a0) > Math.PI ? 1 : 0; // large-arc-flag (imprescindible con n=1)
  const px = (ang, rad) => [cx + rad * Math.cos(ang), cy + rad * Math.sin(ang)];
  const [x0o, y0o] = px(a0, R), [x1o, y1o] = px(a1, R);
  const [x1i, y1i] = px(a1, r), [x0i, y0i] = px(a0, r);
  return `M${f(x0o)} ${f(y0o)} A${R} ${R} 0 ${grande} 1 ${f(x1o)} ${f(y1o)} `
    + `L${f(x1i)} ${f(y1i)} A${r} ${r} 0 ${grande} 0 ${f(x0i)} ${f(y0i)} Z`;
}

// Sector anular del trozo i de n. Empieza ARRIBA (−π/2) y gira con el reloj.
export function sectorAnular(cx, cy, R, r, i, n, hueco, dec = 1) {
  const a0 = (i / n) * 2 * Math.PI - Math.PI / 2 + hueco;
  const a1 = ((i + 1) / n) * 2 * Math.PI - Math.PI / 2 - hueco;
  return sectorAngulos(cx, cy, R, r, a0, a1, dec);
}

// §3.2.6 · el trozo suelto · un solo sector centrado ARRIBA (marcador de fila).
export function trozoSuelto(n) {
  const med = Math.PI / Math.max(n, 1);
  return sectorAngulos(10, 10, 9.2, 4.7, -Math.PI / 2 - med, -Math.PI / 2 + med, 2);
}

// El GRANDE (§3.2.3) · un trozo por ejercicio del día. estados[i] = 'hecha'|'parada'|''.
// momentos[i] = 'manana'|'tarde'|'noche' (para el gris del momento en los que faltan).
export function trozosGrande(estados, momentos, nombres) {
  const n = Math.max(estados.length, 1);
  return estados.map((est, i) => {
    let cls = est === 'hecha' ? 'es-hecho' : est === 'parada' ? 'es-parada' : 'es-falta';
    if (cls === 'es-falta') cls += ' es-' + (momentos[i] || 'manana');
    return { d: sectorAnular(70, 70, 62, 30, i, n, 0.035, 1), cls, titulo: (nombres && nombres[i]) || '' };
  });
}

// El ROSCO del día (§3.2.5) · un trozo por ejercicio. est = 'si'|'no'|'medias'|'dolor'.
export function trozosRosco(estados) {
  const n = Math.max(estados.length, 1);
  return estados.map((est, i) => ({
    d: sectorAnular(16, 16, 15, 8.6, i, n, 0.10, 1),
    cls: 'es-' + (est || 'no'),
  }));
}
